module.exports = __webpack_public_path__ + "img/cta-hold.cd527ea9.jpg";